import { computed, ref } from 'vue'
import { getWhitelistedIPsList, GetWhitelistedIPsResponse } from './api'

export * from './types'

const whitelistedIPs = ref<GetWhitelistedIPsResponse>([])

const getWhitelistedIPs = () => getWhitelistedIPsList().then((whitelistedIPsList) => {
    whitelistedIPs.value = whitelistedIPsList
})

export function useWhitelistedIPsModule () {
    return {
        whitelistedIPs: computed(() => whitelistedIPs.value),
        getWhitelistedIPs
    }
}
